import { render, staticRenderFns } from "./WithdrawReportModal.vue?vue&type=template&id=845c0876"
import script from "./WithdrawReportModal.vue?vue&type=script&lang=js"
export * from "./WithdrawReportModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawReportModal.vue?vue&type=style&index=0&id=845c0876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports